import Vue from 'vue';
import Vuex from 'vuex';
import { getProducts } from './api';

Vue.use(Vuex);

const state = {
    productList: [],
    navigatorList: [],
};

const mutations = {
    setProductList (state, productList) {
        state.productList = productList;
    },
    setNavigatorList (state, navigatorList) {
        state.navigatorList = navigatorList;
    },
    
};

const actions = {
    async getProducts ({commit}, id) {
        return getProducts(id).then(res => {
            const {navigator_list, goods_list} = res.data;
            commit('setProductList', goods_list);
            commit('setNavigatorList', navigator_list);
            
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/stores/request.js